import { useEffect, useState } from "react";

const STORAGE_KEY = "steffi_public_lang";
const IP_LOCATION_URL = "https://ipwho.is/";
let ipLanguagePromise;

function getStoredPublicLang() {
  if (typeof window === "undefined") return null;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored === "de" || stored === "en" ? stored : null;
  } catch {
    return null;
  }
}

function getBrowserPublicLang() {
  if (typeof navigator === "undefined") return null;
  const browserLanguage = navigator.languages?.[0] || navigator.language;
  if (!browserLanguage) return null;
  return browserLanguage.toLowerCase().startsWith("de") ? "de" : "en";
}

function getIpPublicLang() {
  if (!ipLanguagePromise) {
    ipLanguagePromise = fetch(IP_LOCATION_URL)
      .then((response) => {
        if (!response.ok) throw new Error();
        return response.json();
      })
      .then((data) => data.success !== false && data.country_code === "DE" ? "de" : "en")
      .catch(() => "en");
  }
  return ipLanguagePromise;
}

export function getPublicLang() {
  return getStoredPublicLang() || getBrowserPublicLang() || "en";
}

export function setPublicLang(lang) {
  if (typeof window === "undefined") return;
  const next = lang === "en" ? "en" : "de";
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch {
    // The current page still changes language when storage is unavailable.
  }
  window.dispatchEvent(new CustomEvent("public-lang-change", { detail: next }));
}

export function usePublicLanguage() {
  const [lang, setLangState] = useState(() => getPublicLang());

  useEffect(() => {
    let cancelled = false;
    const handler = () => setLangState(getPublicLang());
    window.addEventListener("public-lang-change", handler);
    window.addEventListener("storage", handler);

    if (!getStoredPublicLang() && !getBrowserPublicLang()) {
      getIpPublicLang().then((detectedLang) => {
        if (!cancelled && !getStoredPublicLang() && !getBrowserPublicLang()) {
          setLangState(detectedLang);
        }
      });
    }

    return () => {
      cancelled = true;
      window.removeEventListener("public-lang-change", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const setLang = (next) => {
    setPublicLang(next);
    setLangState(next === "en" ? "en" : "de");
  };

  return { lang, setLang };
}
